import type { Tool, ToolDefinition } from '@repo/shared-types';

/**
 * Get the display label for a tool value
 * Falls back to the value itself if not found in the tools list
 */
export function getToolLabel(tool: Tool, tools: ToolDefinition[]): string {
  const found = tools.find((t) => t.value === tool);
  return found?.label || tool;
}
